import { useScorecardStore } from '../stores/scorecardStore'

import { registerSessionReset } from '@/features/auth'

/** Logout clears the loaded targets so a degraded next-account boot can never retain
 *  prior-tenant data (contract 10 §7). The lens/lifecycle toggles are session-ephemeral
 *  UI state and stay untouched by design. */
export function registerScorecardSessionReset(): () => void {
  const store = useScorecardStore()
  return registerSessionReset(() => store.reset())
}
